// Import logos
import masstro from "../assets/collabs/Masstro.jpeg";
import surrey from "../assets/collabs/U of Surrey.jpg";
import tmc from "../assets/collabs/tmc.jpg";
import nitk from "../assets/collabs/nitk.svg";
import cdac from "../assets/collabs/cdac.jpg";
import washington from "../assets/collabs/U of Washington.jpg";

export const collabdata = [{
        institution: "MAASTRO Clinic",
        logo: masstro,
        people: [{
                name: "Dr Andre Dekker",
                department: "Professor, Clinical Data Science",
            },
            {
                name: "Dr Leonard Wee",
                department: "Assistant Professor, Clinical Data Science",
            }

        ]

    },
    {
        institution: "Tata Medical Centre",
        logo: tmc,
        people: [{
                name: "Dr Indranil Mallik",
                department: "Consultant, Radiation Oncology."
            },
            {
                name: "Dr Santam Chakraboraty",
                department: "Consultant, Radiation Oncology."
            },
        ]
        
    },
    {
        institution: "National Institute of Technology Karnataka, Surathkal",
        logo: nitk,
        people: [{
                name: "Dr Jeny Rajan, Ph.D.",
                department:"Assistant Professor, Computer Science and Engineering"
            },
        ]
        
    },
    {
        institution: "Centre for Development of Advanced Computing (C-DAC), Pune, India ",
        logo: cdac,
        people: [{
                name: "Dr. Lakshmi Panat",
                department:"Associate Director, Scientist G"
            },
        ]

    },
    {
        institution: "University of Surrey",
        logo: surrey,
        people: [{
                name: "Dr Philip Evans",
                department: "Emeritus Professor, Centre for Vision, Speech and Signal Processing",
            }
    
        ]
    
    },
    {
        institution: "University of Washington",
        logo: washington,
        people: [{
            name: "Dr Stephen Bowen",
            department: "Professor, Radiology & Radiation Oncology"
    
        }]
    },
];